/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 * @dependencies jQuery
 * @dependencies foundation.dropdownMenu.js
 */

import Headroom from 'headroom.js';
import $ from 'jquery';

// Header Element
const headerEl = document.querySelector('.js-fixed-header');
const bannerEl = document.querySelector('.js-banner');
const sizeChangeEvents = ['resize', 'orientationchange'];

if (headerEl) {
  const scrollTopBtn = document.querySelector('.js-scrolltop');
  const bannerHeight = bannerEl ? bannerEl.offsetHeight : 0;

  const calcHeaderHeight = () => {
    const headerHeight = headerEl.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      ` ${headerHeight}px`
    );
    const bannerHeight = bannerEl ? bannerEl.offsetHeight : 0;
    document.documentElement.style.setProperty(
      '--banner-height',
      ` ${bannerHeight}px`
    );
  };

  window.fixedHeader = {};

  // Headroom Options
  fixedHeader = new Headroom(headerEl, {
    offset: bannerHeight,
    tolerance: {
      up: 0,
      down: 8,
    },
    classes: {
      // when element is initialised
      initial: 'initialized',
      // when scrolling up
      pinned: 'is-pinned',
      // when scrolling down
      unpinned: 'is-unpinned',
      // when above offset
      top: 'is-top',
      // when below offset
      notTop: 'is-not-top',
      // when at bottom of scoll area
      bottom: 'is-bottom',
      // when not at bottom of scroll area
      notBottom: 'is-not-bottom',
    },
    onTop: function () {
      if (scrollTopBtn) {
        scrollTopBtn.classList.remove('scrolltop--visible');
      }
    },
    onNotTop: function () {
      // When we have a sticky header & a searchbar, PIN the header
      const algoliaSearch = headerEl.querySelector('#search-autocomplete');
      if (algoliaSearch) {
        const searchInput = Array.from(algoliaSearch.getElementsByClassName('aa-Input'));

        searchInput.forEach((input) => {
          input.addEventListener('focus', function() {
            headerEl.classList.add('headroom--frozen');
          });

          input.addEventListener('blur', function() {
            headerEl.classList.remove('headroom--frozen');
          });
        });
      }

      if (scrollTopBtn) {
        scrollTopBtn.classList.add('scrolltop--visible');
      }
    },
  });

  window.addEventListener('load', function () {
    fixedHeader.init();
    calcHeaderHeight();

    sizeChangeEvents.forEach((event) => {
      window.addEventListener(event, debounce(calcHeaderHeight));
    });
  });

  // If on search pages with Algolia, avoid menu bouncing on and off with facets
  const algoliaWidgets = document.querySelector('.js-algolia-filters');

  if (algoliaWidgets) {
    algoliaWidgets.addEventListener('click', function () {
      fixedHeader.destroy();
    });

    window.addEventListener('scroll', debounce(scrolledTop));
  }

  // Prevent header to show on close reveal
  const reveals = document.getElementsByClassName('reveal');
  for (let index = 0; index < reveals.length; index++) {
    const reveal = reveals[index];

    $(reveal).on('closed.zf.reveal', function () {
      headerEl.style.transition = 'none';
      setTimeout(() => {
        headerEl.style.transition = '';
      }, 100);
    });
  }
}

function scrolledTop() {
  if (window.scrollY === 0 && !headerEl.classList.contains('headroom--frozen')) {
    fixedHeader.init();
  }
}

// Debounce the event to avoid too many triggers
function debounce(func, timeout = 250) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
